import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@gonka-wallet/ui-tokens';

export function WalletWiped() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col bg-bg px-5 pb-6 pt-3 text-text-primary">
      <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
        <div className="flex h-[72px] w-[72px] items-center justify-center rounded-[20px] bg-surface-2 text-[36px] text-text-tertiary">
          &#8856;
        </div>
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[1.4px] text-text-tertiary">
            {t('wiped.removedLabel')}
          </div>
          <div className="mt-1.5 text-[20px] font-semibold tracking-[-0.5px] text-text-primary">
            {t('wiped.title')}
          </div>
          <div className="mt-2 text-[13px] leading-relaxed text-text-secondary">
            {t('wiped.body')}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2.5">
        <Button variant="primary" fullWidth onClick={() => navigate('/create')}>
          {t('wiped.createButton')}
        </Button>
        <Button variant="secondary" fullWidth onClick={() => navigate('/import')}>
          {t('wiped.importButton')}
        </Button>
      </div>
    </div>
  );
}
